
const state = () => ({
  currentStep: 'step1',
  notificationInstance: null,
  companyCreated: false,
  lastStep: 1,
  linkAccount: {
    isLinkAccount: false,
    userData: {},
    idpUuid: null,
  },
  done: {
    step1: false,
    step2: false,
    step3: false,
  },
  info: {
    companySizes: [],
    countries: [],
    extraFields: [],
    legalForms: [],
    sectorEntities: [],
    titles: [],
    csOperator: null,
    legalDocuments: {
      generic: [],
      operator: [],
    },
  },
  data: {

    // STEP 1
    companyEmail: '', // Only when user is creating his business account from scratch
    password: '', // Only when user is creating his business account from scratch
    title: '', // Only when user is creating his business account from scratch
    firstName: '', // Only when user is creating his business account from scratch
    lastName: '', // Only when user is creating his business account from scratch
    datebirth: null, // Only when user is creating his business account from scratch
    phoneNumber: '', // Only when user is creating his business account from scratch
    companyName: '',
    country: '',
    taxNumber: '',
    workEmail: '', // When user is linking his personal account
    workPhoneNumber: '', // When user is linking his personal account

    // STEP 2
    companyAddress: '',
    extraCompanyAddress: '',
    legalForm: '',
    sectorEntity: '',
    companySize: '',

    // STEP 3
    adminID: '',
    adminIDBase64: '',
    adminCountryCode: '',
    adminFiscalNumber: '',
    fiscalCode: '',
    incorporationProof: '',
    incorporationProofBase64: '',
    italyTermsAndConditions: false,
    operatorTermsAndConditions: false,
    siretNumber: '',
    taxError: null,
    termsAndConditions: false,
    marketingTerms: false,
  },
});
export default state;
